module.exports = __webpack_public_path__ + "img/doctor.85bced5f.png";